import * as React from "react";

import { SignatureFieldViewStyle } from "./signature-field-view-style";
import { CancelIcon } from "../../../media/icons";
import { isEmptyOrUndefined } from "common/Support";

interface SignatureFieldViewProps {
    readonly isEnabled: boolean;
    readonly title: string;
    readonly placeholder: string;
    readonly onTap?: () => void;
    readonly onClear?: () => void;
    readonly imageUrl?: string;
}

const SignatureFieldView: React.FunctionComponent<SignatureFieldViewProps> = (props: SignatureFieldViewProps) => {
    const { isEnabled, title, placeholder, onTap, onClear, imageUrl } = props;
    const hasImage = !isEmptyOrUndefined(imageUrl);

    const clearPreventPropagation = (evt: React.MouseEvent) => {
        evt.stopPropagation();
        if (onClear === undefined) return;
        onClear();
    };

    const onTapIfEnabled = () => {
        if (!isEnabled || onTap === undefined) return;
        onTap();
    };

    return (
        <SignatureFieldViewStyle
            data-test="app-signature-field-view"
            onClick={onTapIfEnabled}
            role="button"
            aria-label={`Edit ${title}`}>
            <div className="sf-inner">
                <div className="sf-title-container">
                    <div className="sf-title">{title}</div>
                    {hasImage && (
                        <button title={`Clear ${title}`} className="sf-clear-icon" onClick={clearPreventPropagation}>
                            <CancelIcon />
                        </button>
                    )}
                </div>

                {hasImage ? (
                    <img className="sf-placeholder" alt="" src={imageUrl} />
                ) : (
                    <div className="sf-placeholder">{placeholder}</div>
                )}
            </div>
        </SignatureFieldViewStyle>
    );
};

export default SignatureFieldView;
